import { ModelApiService } from './BaseApiService'

export default class LocationsApiService extends ModelApiService {
  constructor() {
    super('locations')
  }

  async getBookingLocations() {
    return this.get(`booking-location-list`)
  }

  async getLocationCertifications(locationId) {
    return this.get(`${locationId}/certifications`)
  }

  async getLocationBookingBlocks() {
    return this.get(`booking-blocks`)
  }

  async getCertifications(payload) {
    return await this.post('certifications', payload)
  }

  async getReplacing(payload) {
    return await this.post('booking-contacts', payload)
  }
}
